import {Component, EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {Router} from '@angular/router';
import {LinkItem} from '@catui/types';

const componentBaseName = 'panel-linked-list';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

/**
 * A component to provide styled list which can be used in a Panel component
 */
@Component({
  selector: 'cat-panel-linked-list',
  templateUrl: './panel-linked-list.component.html',
  styleUrls: ['./panel-linked-list.component.scss'],
})
export class PanelLinkedListComponent {
  @HostBinding('class') classNames = defaultClassNames;
  @Input() items: LinkItem[];
  @Input() title: string = null;
  @Input() noItemPlaceholder = 'No items yet';
  @Input() hoverEnabled: boolean = true;
  private _selectionEnabled: boolean = false;

  /**
   * Emits the current selection on each update as an array of LinkItems.
   */
  @Output() onSelectionUpdate = new EventEmitter<any>();

  private selectedItems: LinkItem[] = [];

  constructor(private routerService: Router) {
  }

  /**
   * If set to true, a click on a list item will select (or deselect) an item instead of triggering the
   * item action. To keep updated on the selection, use the event emitter onSelectionUpdate.
   * Setting this value to false clears an existing selection.
   *
   * @param value
   */
  @Input() set selectionEnabled(value: boolean) {
    this._selectionEnabled = value;
    if (!this._selectionEnabled) {
      this.selectedItems = [];
      this.onSelectionUpdate.emit(this.selectedItems);
    }
  }

  get selectionEnabled(): boolean {
    return this._selectionEnabled;
  }

  isSelected(item: LinkItem) {
    return this.selectedItems.includes(item);
  }

  onClick(item: LinkItem) {
    if (this.selectionEnabled) {
      if (this.isSelected(item)) {
        this.deselect(item);
      } else {
        this.select(item);
      }
      this.onSelectionUpdate.emit(this.selectedItems);
    } else {
      item.navigate(this.routerService);
    }
  }

  private select(item) {
    this.selectedItems.push(item);
  }

  private deselect(item) {
    this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
  }

  selectAll() {
    this.selectedItems = [...this.items];
    this.onSelectionUpdate.emit(this.selectedItems);
  }

  deselectAll() {
    this.selectedItems = [];
    this.onSelectionUpdate.emit(this.selectedItems);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/ui-base/components/panel-linked-list/panel-linked-list.component.ts